import { render, staticRenderFns } from "./SurveysIndex.vue?vue&type=template&id=c23fe588&scoped=true&"
import script from "./SurveysIndex.vue?vue&type=script&lang=js&"
export * from "./SurveysIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23fe588",
  null
  
)

export default component.exports